import { createFileRoute } from '@tanstack/react-router';
import type { UsersPatch } from '../../../features/users/user-filters.tsx';
import { UsersPage } from '../../../features/users/users-page.tsx';
import { validateUsersSearch, type UsersSearch } from '../../../features/users/users-search.ts';
import { guardPermission } from '../../../shell/guard.ts';

// Owner admin: people and access (spec F18, J9). Filters are search params, so Back returns to the
// previous filters (constitution §5.6).
export const Route = createFileRoute('/_authed/admin/users')({
  beforeLoad: guardPermission('user.manage'),
  validateSearch: validateUsersSearch,
  component: UsersRoute,
});

function UsersRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearch = (patch: UsersPatch, opts: { readonly keepPage?: boolean } = {}): void => {
    void navigate({
      // The patch holds raw form values; the same check as the URL turns them into filters.
      search: (prev: UsersSearch) =>
        validateUsersSearch({
          ...prev,
          ...patch,
          ...(opts.keepPage === true ? {} : { page: undefined }),
        }),
    });
  };
  return <UsersPage search={search} onSearch={onSearch} />;
}
